module.exports = __webpack_public_path__ + "img/poisson.e94f2f0e.png";